import { Timings } from '@meshwatch/node-fetch';
import {
  ErrorLatencyCheck,
  LatencyCheckDTO,
  LatencyCheckResult,
  SuccesffulLatencyCheck,
} from '@meshwatch/types';
import { get } from 'lodash';
import { QueryConfig, QueryResult } from 'pg';

import PostgresClient, { DEFAULT_POSTGRES_CLIENT } from '../../../shared/postgres';
import AbstractTimescaleMonitorCheckDatasource from '../db';
import { CHECKS_SCHEMA } from '../schema';
import { IdentifiableMonitorExecutorCheck } from '../types';

import { CREATE_HYPERTABLE_SQL, CREATE_TABLE_SQL, LATENCY_TABLE_NAME } from './schema';
import { GetMonitorLatencyChecksParams, LatencyInsertParams } from './types';

export interface LatencyCheckDatasource {
  getLatencyChecks(params: GetMonitorLatencyChecksParams): Promise<LatencyCheckDTO[]>;
  insertCheckData(params: LatencyInsertParams): Promise<LatencyCheckDTO>;
  createTable(): Promise<QueryResult>;
}

export class TimescaleLatencyCheckDatasource extends AbstractTimescaleMonitorCheckDatasource
  implements LatencyCheckDatasource {
  public constructor(client: PostgresClient = DEFAULT_POSTGRES_CLIENT) {
    super(client);
  }

  public createTable = (): Promise<QueryResult> => {
    return this.client.query(CREATE_TABLE_SQL).then(_ => {
      return this.client.query(CREATE_HYPERTABLE_SQL);
    });
  };

  public getLatencyChecks = (params: GetMonitorLatencyChecksParams): Promise<LatencyCheckDTO[]> => {
    return this.getMonitorChecks({ ...params, tableName: LATENCY_TABLE_NAME });
  };

  public insertCheckData = (
    data: IdentifiableMonitorExecutorCheck<LatencyCheckResult>
  ): Promise<LatencyCheckDTO> => {
    return this.insertLatencyCheck(data);
  };

  private insertLatencyCheck = (params: LatencyInsertParams): Promise<LatencyCheckDTO> => {
    const insertLatencyCheckConfig = this.getInsertQueryConfig(params);
    return this.client.query(insertLatencyCheckConfig).then(resp => {
      const latencyRow = resp.rows[0] as LatencyCheckDTO;
      return latencyRow;
    });
  };

  private getInsertQueryConfig({
    userId,
    monitorId,
    region,
    data,
    created,
  }: LatencyInsertParams): QueryConfig {
    const timings: Timings = get(data, 'timings', {});
    const blobSize = (data as SuccesffulLatencyCheck).blobSize;
    const error = (data as ErrorLatencyCheck).error;
    return {
      name: 'insert-latency-check',
      text:
        `INSERT INTO ${CHECKS_SCHEMA}.${LATENCY_TABLE_NAME} ` +
        '(time, user_id, monitor_id, region, status, error, total_time, tls_handshake_time, tcp_connection_time, dns_lookup_time, first_byte_time, blob_size) ' +
        'VALUES($1, $2, $3, $4, $5, $6, $7, $8, $9, $10, $11, $12) RETURNING *',
      values: [
        created,
        userId,
        monitorId,
        region,
        data.httpStatus,
        error,
        timings.totalTime,
        timings.tlsHandshakeTime,
        timings.tcpConnectionTime,
        timings.dnsLookupTime,
        timings.firstByteTime,
        blobSize,
      ],
    };
  }
}

const timescaleLatencyCheckDatasource = new TimescaleLatencyCheckDatasource();

export default timescaleLatencyCheckDatasource;
